<template>
  <div class="m-l-50 m-t-30" v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="应用名称" prop="name">
        <el-input class="h-40 w-200" v-model="form.name" placeholder="请填写应用名称"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.description" type="textarea" :rows="2" class="h-40 w-200" placeholder="请填写应用描述"></el-input>
      </el-form-item>
      <el-form-item label="应用类型" label-width="100px" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio label="10">企业微信</el-radio>
          <el-radio label="20">WAP</el-radio>
          <el-radio label="30">APP</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="主题样式" label-width="100px" prop="theme">
        <el-select v-model="form.theme" placeholder="请选择主题样式">
          <el-option v-for="theme in themeList" :label="theme.title" :value="theme.theme"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用入口" label-width="100px" prop="entrance">
        <el-select v-model="form.entrance" placeholder="请选择应用入口">
          <el-option v-for="item in pages" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save()" :loading="btnLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from 'assets/js/http'
  import mobileConfig from 'config/mobileConfig.js'

  export default {
    name: 'application-form',
    props: {
      id: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        loading: true,
        btnLoading: false,
        form: {
          name: '',
          description: '',
          type: null,
          theme: null,
          entrance: null
        },
        rules: {
          name: [
            { required: true, message: '请填写应用名称', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择应用类型', trigger: 'change' }
          ],
          theme: [
            { required: true, type: 'number', message: '请选择主题样式', trigger: 'change' }
          ],
          entrance: [
            { required: true, type: 'number', message: '请选择应用入口', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      async getPages() {
        let pages = []
        const result = await this.apiGet('mobile/page/index')
        // console.log('result = ', result)
        if (result.code == 200) {
          pages = result.data
        }
        return pages
      },
      async getAppInfo() {
        let info = null
        if (this.id) {
          const result = await this.apiGet(`mobile/use/get/${this.id}`)
          if (result.code == 200) {
            info = result.data
          }
        }
        return info
      },
      save() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.btnLoading = !this.btnLoading
            const postData = _.cloneDeep(_g.s2j(_g.j2s(this.form)))
            if (this.id) {
              this.edit(postData)
            } else {
              this.add(postData)
            }
          }
        })
      },
      add(postData) {
        this.apiPost('mobile/use/save', postData).then((res) => {
          this.handleResult(res)
        })
      },
      edit(postData) {
        this.apiPut('mobile/use/save/', this.id, postData).then((res) => {
          this.handleResult(res)
        })
      },
      handleResult(res) {
        if (res.code == 200) {
          if (this.id) {
            _g.toastMsg(this, 'success', '修改成功！')
          } else {
            _g.toastMsg(this, 'success', '添加成功！')
          }
          setTimeout(() => {
            this.goback()
          }, 1000)
        } else {
          _g.dealError(this, res)
          this.btnLoading = false
        }
      },
      goback() {
        router.go(-1)
      }
    },
    async created() {
      this.pages = await this.getPages()
      const info = await this.getAppInfo()
      this.loading = false
      if (info) {
        this.form = info
      }
    },
    mixins: [http, mobileConfig]
  }
</script>


// WEBPACK FOOTER //
// form.vue?6d59cd6e